import { StandardEvents } from '@shopify/events';

// Mark the destination while keeping the theme's single, validated add request.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const component = form.closest('product-form-component');
  if (!component || !form.querySelector('[data-cf-buy-now]')) return;
  if (component.dataset.cfCheckoutBusy === 'true') {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }
  const direct = event.submitter?.matches('[data-cf-buy-now]');
  component.dataset.cfCheckoutDirect = direct ? 'true' : 'false';
  if (direct) {
    const add = form.querySelector('button[name="add"]');
    if (add?.disabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
      component.dataset.cfCheckoutDirect = 'false';
      return;
    }
    const quantitySelector = component.querySelector('quantity-selector-component');
    if (quantitySelector?.canAddToCart && !quantitySelector.canAddToCart().canAdd) {
      component.dataset.cfCheckoutDirect = 'false';
      return;
    }
    component.dataset.cfCheckoutBusy = 'true';
    event.submitter.disabled = true;
    event.submitter.setAttribute('aria-busy', 'true');
  }
}, true);

function releaseCheckout(component) {
  if (!component) return;
  delete component.dataset.cfCheckoutBusy;
  delete component.dataset.cfCheckoutDirect;
  const button = component.querySelector('[data-cf-buy-now]');
  if (button) {
    button.disabled = Boolean(component.querySelector('button[name="add"]')?.disabled);
    button.removeAttribute('aria-busy');
  }
}

// Reuse the native cart result: never issue a second add-to-cart request.
document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
  if (!event.promise) return;
  const component = event.target instanceof Element ? event.target.closest('product-form-component') : null;
  try {
    const { detail } = await event.promise;
    if (detail?.didError || !Array.isArray(detail?.items)) { releaseCheckout(component); return; }
    const count = detail.items.reduce((total, item) => total + Number(item.quantity || 0), 0);
    const cartLink = document.querySelector('.cf-header-actions a:has(.cf-cart-count)');
    if (cartLink) {
      cartLink.querySelector('.cf-cart-count').textContent = String(count);
      cartLink.setAttribute('aria-label', `${cartLink.getAttribute('title')}: ${count}`);
    }
    // Product pages use the custom header, so the native drawer is not available.
    // Show the confirmed basket instead of leaving the shopper without feedback.
    if (event.action === 'add' && detail.source === 'product-form-component' &&
        event.target instanceof Element && event.target.closest('.product-information') && cartLink) {
      if (component?.dataset.cfCheckoutDirect === 'true') {
        window.location.assign(cartLink.href.replace(/\/cart\/?(?:\?.*)?$/, '/checkout'));
      } else {
        window.location.assign(cartLink.href);
      }
    }
  } catch {
    releaseCheckout(component);
    // Native product-form error handling owns failures; do not imply success.
  }
});
